import { List, ListItem, Typography, Paper, Divider, Grid } from '@mui/material';
import React from 'react';
import { ContentContainer } from '../ContentContainer';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { AppRoute } from '../../routes';
import { MeshDeviceDetails } from '../../types/device';
import deviceStyles from '../../app/device-management/DeviceStyle';
import { LabelWithSubTitle } from '../LabelWithSubTitle/LabelWithSubtitle';
import { NavigationHeader } from '../NavigationHeader/NavigationHeader';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { GetPartNumberProvider } from '../../data/DataProviders/GetPartNumberProvider';
import { MeshSubscriptionInfo } from './MeshSubscriptionInfo';
import moment from 'moment';

export const MeshDeviceProfileData: React.FC<{
    backAppRoute: AppRoute;
    data: MeshDeviceDetails | null;
}> = (props) => {
    const currentAppRoute = useCurrentAppRoute();
    const classes = deviceStyles();



    return (
        <>
            <ContentContainer>
                {props.data && currentAppRoute.type === 'MeshDeviceProfile' && (
                    <>
                        <NavigationHeader
                            for="Connected Device"
                            siteName={props.data.profile.siteName}
                            connectedDevice={props.data.profile.name || ''}
                            device={''}
                        />
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <Paper>
                                    <List>
                                        <ListItem data-testid="device-name">
                                            <Typography variant="h6" color="primary">
                                                {props.data.profile.name}
                                            </Typography>
                                        </ListItem>
                                        <ListItem data-testid="device-type" className={classes.margin8}>
                                            <LabelWithSubTitle
                                                title={props.data.profile.name}
                                                subTitle="Connected Device Type"
                                            />
                                        </ListItem>
                                        <Divider />
                                        <ListItem data-testid="serial-number" className={classes.margin8}>
                                            <LabelWithSubTitle
                                                title={moment(props.data.dayLightSavingInfo.dayLightSavingStart).format('MM/DD/YYYY')}

                                                subTitle="DayLight Saving Start Date"
                                            />
                                        </ListItem>
                                        <Divider />
                                        <ListItem data-testid="serial-number" className={classes.margin8}>
                                            <LabelWithSubTitle
                                                title={moment(props.data.dayLightSavingInfo.dayLightSavingEnd).format('MM/DD/YYYY')}
                                                subTitle="DayLight Saving End Date"
                                            />
                                        </ListItem>
                                        <Divider />

                                        <ListItem data-testid="imei" className={classes.margin8}>
                                            <LabelWithSubTitle
                                                title={props.data.telemetryData.groupCount}
                                                subTitle="Groups"
                                            />
                                        </ListItem>
                                        <Divider />
                                        <ListItem data-testid="imei" className={classes.margin8}>
                                            <LabelWithSubTitle
                                                title={props.data.telemetryData.deviceCount}
                                                subTitle="Devices"
                                            />
                                        </ListItem>
                                    </List>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DataProviderCache for={'get-part-data'}>
                                    <GetPartNumberProvider siteId={currentAppRoute.siteId}>
                                        <MeshSubscriptionInfo siteName={props.data.profile.siteName} />
                                    </GetPartNumberProvider>
                                </DataProviderCache>
                            </Grid>
                        </Grid>
                    </>
                )}
            </ContentContainer>
        </>
    );
};
